"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Overview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1475438/img/laboratory_precision_scene.png)] bg-cover bg-center transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] hover:scale-[1.02]" />

      {}
      <div className="absolute inset-0 bg-secondary/60 backdrop-blur-sm" />

      {}
      <div className="relative z-10 max-w-4xl mx-auto px-6 py-16 text-center">
        {}
        <h1 className={`font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>Technical Intelligence for High-Stakes Decisions</h1>

        {}
        <p className={`text-lg md:text-xl text-white/95 mb-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
        transitionDelay: isVisible ? "100ms" : "0ms"
      }}>We provide clear, rigorous technical evaluations to support intellectual property, due diligence, and complex engineering challenges.</p>
      </div>
    </section>;
}